import { Tag } from "antd";

export const renderStatusBadge = (status: string) => {
  switch (status) {
    case "pending":
      return <Tag color="orange">Pending</Tag>;
    case "Processing":
      return <Tag color="blue">Processing</Tag>;
    case "Success":
      return <Tag color="green">Success</Tag>;
    case "Failed":
      return <Tag color="red">Failed</Tag>;
    default:
      return <Tag>Unknown</Tag>;
  }
};
